<template>
  <div class="q-mt-lg">
    <div
      class="row col-12 q-ml-md justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
      style="font-size: 16px"
    >
      <span> Produtos desta Necessidade </span>
      <q-btn
        @click="exportar"
        class=""
        style="border-radius: 8px; background-color: #304f78; color: white"
        no-caps
        icon="file_upload"
        label="Exportar"
      />
    </div>
    <q-table
      flat
      table-header-style="background-color: #d9effc"
      color="primary"
      :rows="rows"
      dense
      selection="multiple"
      class="tabela-tamanho-fixo"
      :columns="columns"
      :loading="disable"
      v-model:selected="selecionados"
      hide-pagination
      v-model:pagination="pagination"
      :rows-per-page-options="[0]"
      row-key="uuid_item"
      @request="handleRequest"
    >
      <template v-slot:header-selection>
        <q-checkbox
          v-model="selectAll"
          @update:model-value="toggleSelectAll"
          :indeterminate="
            selecionados.length > 0 &&
            selecionados.length < produtosSelecionaveis.length
          "
        />
        <q-tooltip>Selecionar todos</q-tooltip>
      </template>
      <template v-slot:body-selection="props">
        <q-checkbox
          v-if="props.row.purchase_order_id == null"
          v-model="props.selected"
        />
      </template>
      <template #body-cell-editar="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-btn
              v-if="props.row.editar == undefined || props.row.editar == false"
              @click="props.row.editar = !props.row.editar"
              class="q-ml-md"
              icon="sym_o_edit"
              round
              flat
              color="primary"
              :disable="props.row.purchase_order_id != null"
            />

            <q-btn
              v-if="props.row.editar == true"
              @click="editar(props.row), (props.row.editar = !props.row.editar)"
              icon="sym_o_check"
              flat
              round
              color="positive"
            />
          </div>
        </q-td>
      </template>

      <template #body-cell-responsavel="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div style="max-width: 240px" class="text-brand-5 text-weight-bold">
            <div v-if="props.row.editar" class="row items-center no-wrap">
              <q-btn
                @click.stop="removerResponsavelItem(props.row)"
                icon="sym_o_close"
                round
                flat
                color="negative"
                size="md"
                dense
                style="margin-left: -1px"
              >
                <q-tooltip
                  anchor="top middle"
                  self="bottom middle"
                  class="bg-negative text-white"
                >
                  Remover responsável
                </q-tooltip>
              </q-btn>

              <SelectSolicitante
                :lengthHidden="100"
                label="Responsavel"
                v-model="props.row.matricula_responsavel"
                class="col"
                @update:model-value="
                  (value) => editarResponsavel(props.row, value)
                "
              />
            </div>
            <span v-else>{{ props.row.responsavel_nome }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-product_codigo="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              style="width: 100px"
              v-if="props.row.editar == true"
              dense
              v-model="props.row.code"
              outlined
              label="Codigo
              "
            >
            </q-input>
            <span v-else>{{ props.row.product_codigo }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-ncm="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row items-center no-wrap">
            <q-btn
              v-if="props.row.editarNcm == undefined || props.row.editarNcm == false"
              @click="props.row.editarNcm = true"
              icon="sym_o_edit"
              round
              flat
              size="sm"
              color="primary"
              :disable="props.row.purchase_order_id != null"
              dense
            >
              <q-tooltip>Editar NCM</q-tooltip>
            </q-btn>

            <q-btn
              v-if="props.row.editarNcm == true"
              @click="editarNcm(props.row), (props.row.editarNcm = false)"
              icon="sym_o_check"
              flat
              round
              size="sm"
              color="positive"
              dense
            >
              <q-tooltip>Confirmar NCM</q-tooltip>
            </q-btn>

            <q-input
              v-if="props.row.editarNcm == true"
              style="width: 100px"
              dense
              v-model="props.row.ncm"
              outlined
              label="NCM"
              class="q-ml-xs"
            >
            </q-input>
            <span v-else>{{ props.row.produto_ncm }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-item_cost_center_code="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div style="max-width: 240px" class="row">
            <SelectCentroCustos
              label="Unid. Controle"
              v-if="props.row.editar == true"
              v-model="props.row.item_cost_center_code_new"
            />

            <span v-else>{{ props.row.item_cost_center_code }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-cost_center_code="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              v-if="props.row.editar == true"
              style="width: 70px"
              dense
              v-model="props.row.cost"
              outlined
              label="Centro"
            >
            </q-input>
            <span v-else>{{ props.row.cost_center_code }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-quantidadeNecessaria="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row items-center">
            <q-input
              v-if="props.row.editar == true"
              style="margin-top: 20px"
              dense
              v-model.number="props.row.quantidade_necessaria"
              outlined
              label="Quantidade"
              type="number"
              min="0"
              :rules="[(val) => val >= 0 || 'Quantidade deve ser positiva']"
            />
            <span v-else>{{ formatQuantidade(props.row.quantidade_necessaria) }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-purchase_order_price="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div class="row">
            <q-input
              style="min-width: 120px"
              v-if="props.row.purchase_order_price == null"
              dense
              v-model="props.row.price"
              outlined
              label="Preço"
              @update:model-value="salvarPreco(props.row)"
            >
            </q-input>

            <span v-else>{{ props.row.purchase_order_price }}</span>
          </div>
        </q-td>
      </template>

      <template #body-cell-delete="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <q-btn
            @click="deletar(props.row.uuid_item_fora_catalogo)"
            icon="close"
            round
            flat
            :disable="props.row.uuid_item_fora_catalogo == null"
            color="negative"
          />
        </q-td>
      </template>
      <template #body-cell-excluirCodigo="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <q-btn
            @click="excluirCodigo(props.row.uuid_item)"
            icon="sym_o_delete"
            round
            flat
            :disable="props.row.uuid_item_fora_catalogo != null"
            color="negative"
          />
        </q-td>
      </template>

      <template #body-cell-pedidoCompra="props">
        <q-td :class="{ 'my-special-class': props.row.purchase_order_id }">
          <div style="font-size: 15px; font-weight: bolder" class="row">
            <a
              v-if="props.row.purchase_order_id != null"
              class="target"
              rel="noopener noreferrer"
              @click="rota('compras-editar', props.row.purchase_order_id)"
              >{{ props.row.purchase_order_id }}</a
            >
            <span v-else>NÃO</span>
          </div>
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
    <div class="q-mt-xl q-ml-md">
      <q-btn
        @click="criarRequisicao"
        class="q-ml-sm"
        no-caps
        style="border-radius: 8px; background-color: #21324a; color: white"
        icon="add"
        label="Criar Requisição"
        :disable="selecionados.length == 0"
      />
    </div>
    <compra-aberto
      :selecionados="selecionados"
      @atualizar="getDados"
      @limpar-selecao="selecionados = []"
      @preco-alterado="resetarEstadoIncluir"
    />
  </div>
</template>

<script>
// funçao para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";
  
  let formatted = num.toFixed(4);
  
  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return formatted.replace('.', ',');
};

// funçao para formatar preço (R$ com minimo 2 casas decimais, maximo 4)
const formatPreco = (value) => {
  if (!value && value !== 0) return "R$ 0,00";
  const num = Number(value);
  if (isNaN(num)) return "R$ 0,00";
  
  let formatted = num.toFixed(4);
  
  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return `R$ ${formatted.replace('.', ',')}`;
};

const columns = [
  {
    name: "tempo",
    label: "Inserido em:",
    field: (row) =>
      row.created_at
        ? row.created_at.split(" ")[0].split("-").reverse().join("/") +
          " " +
          row.created_at.split(" ")[1]
        : "Sem data",
    align: "left",

    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "item_cost_center_code",
    label: "Unid. Controle",
    field: "item_cost_center_code",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "responsavel",
    label: "Responsável",
    field: "responsavel",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "product_codigo",
    label: "Codigo",
    field: (row) => row.product_codigo,
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "produto",
    label: "Produto",
    field: (row) => row.produto_nome,
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1; max-width: 300px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;"
        : "max-width: 300px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;",
  },

  {
    name: "medida",
    label: "Unid. Medida SC",
    field: (row) => row.unidade_medida_necessidade,
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "medida",
    label: "Unid. Medida Catalogo",
    field: (row) => row.unidade_medida,
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "ncm",
    label: "NCM",
    field: (row) => row.produto_ncm,
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "quantidadeNecessaria",
    label: "Qtd. de Compra",
    field: (row) => formatQuantidade(row.quantidade_necessaria),
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "purchase_order_price",
    label: "R$ Unitário",
    field: (row) => row.purchase_order_price ? formatPreco(row.purchase_order_price) : "R$ 0,00",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "preco",
    label: "Total",
    field: (row) => {
      if (row.purchase_order_price == null) {
        if (row.price == undefined || row.price == "") {
          return "R$ 0,00";
        }
        const precoUnitario = Number(String(row.price).replace(/,/g, "."));
        const quantidade = Number(String(row.quantidade_necessaria).replace(/,/g, "."));
        const total = precoUnitario * quantidade;
        return formatPreco(total);
      }
      return formatPreco(row.purchase_order_price * row.quantidade_necessaria);
    },
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "replacementAmount",
    label: "Reposição",
    field: (row) => formatQuantidade(row.replacement_amount),
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },

  {
    name: "maxAmount",
    label: "Qtd. Máx",
    field: (row) => formatQuantidade(row.max_amount),
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "amount",
    label: "Qtd. em Estoque",
    field: (row) => formatQuantidade(row.amount),
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "pedidoCompra",
    label: "Ped. Compra",
    field: "pedidoCompra",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },

  {
    name: "editar",
    label: "Editar",
    field: "editar",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "delete",
    label: "Desvincular Codigo",
    field: "delete",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
  {
    name: "excluirCodigo",
    label: "Excluir Codigo",
    field: "excluirCodigo",
    align: "left",
    style: (row) =>
      row.purchase_order_id
        ? "background-color: #C1DEC1;"
        : "white-space: normal",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRoute, useRouter } from "vue-router";
import CompraAberto from "./CompraAberto.vue";
import SelectSolicitante from "../components/SelectSolicitante.vue";
import SelectCentroCustos from "../components/SelectCentroCustos.vue";
export default {
  components: { CompraAberto, SelectSolicitante, SelectCentroCustos },
  props: ["info", "get"],
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const selecionados = ref([]);
    const selectAll = ref(false);
    const id = route.params.id;

    const precosEditados = ref({});

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 25,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 25) => {
      try {
        const response = await store.dispatch(
          "compras/getProdutosNecessidade",
          {
            vendor_id: store.state.org.unidadeData.id,
            page,
            per_page: rowsPerPage,
            uuid: id,
          }
        );

        rows.value = response.data.data;
        console.log(rows.value);

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;
        disable.value = false;
      } catch (error) {
        console.log(error);
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const rota = async (rota, param = "") => {
      if (param != "") {
        router.push({
          name: rota,
          params: { id: param },
        });
      } else {
        router.push({
          name: rota,
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/exportarProdutosNecessidade", {
          vendor_id: store.state.org.unidadeData.id,
          uuid: id,
          download: true,
        });

        $q.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const excluirCodigo = async (uuid) => {
      try {
        await store.dispatch("compras/excluirCodigo", {
          uuid: id,
          uuid_itens: [uuid],
        });

        $q.notify({
          message: "Código excluido com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
        emit("atualizar");
      } catch (error) {
        $q.notify({
          message: "Erro ao excluir código",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const deletar = async (uuid) => {
      try {
        await store.dispatch("compras/deletarProdutosNecessidade", {
          uuid: id,
          produtos: [{ produto_fora_catalogo_uuid: uuid }],
        });

        $q.notify({
          message: "Deletado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
        emit("atualizar");
      } catch (error) {
        $q.notify({
          message: "Erro a o deletar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarRequisicao = async () => {
      let produtos = [];
      selecionados.value.forEach((e) => {
        produtos.push({
          amount: Number(e.quantidade_necessaria),
          id: e.product_id,
          product_id: e.product_id,
          quantidade_necessaria: 0,
        });
      });

      try {
        await store.dispatch("compras/criarRequisicao", {
          cost_center_id: props.info.costCenter.id,
          numero: props.info.numero,
          plantiff_id: props.info.solicitante.usuario.id,
          vendor_id: store.state.org.unidadeData.id,
          products: produtos,
        });

        $q.notify({
          message: "Requisição criada com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editar = async (dados) => {
      try {
        if (
          dados.quantidade_necessaria !== undefined &&
          dados.quantidade_necessaria !== null
        ) {
          await store.dispatch("compras/editarQuantidadeItemNecessidade", {
            uuid: id,
            uuidItem: dados.uuid_item,
            quantidade: dados.quantidade_necessaria,
          });
        }
        if (dados.matricula_responsavel) {
          await store.dispatch("compras/editarProdutosNecessidadeNome", {
            need_id: id,
            matricula_responsavel: dados.matricula_responsavel.sap,
            uuid: dados.uuid_item,
          });
        }
        if (dados.code) {
          await store.dispatch("compras/editarProdutosNecessidadeCode", {
            code: dados.code,
            need_id: id,
            product_uuid: dados.uuid_item,
          });
        }

        if (dados.item_cost_center_code_new) {
          await store.dispatch("compras/editarProdutosNecessidadeCost", {
            cost_center_code: dados.item_cost_center_code_new.code,
            need_id: id,
            uuid: dados.uuid_item,
          });
        }

        $q.notify({
          message: "Editado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getDados();
      } catch (error) {
        $q.notify({
          message: error.response?.data?.message || "Erro ao editar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        if (dados.quantidadeOriginal !== undefined) {
          dados.quantidade_necessaria = dados.quantidadeOriginal;
        }
      }
    };

    const editarNcm = async (dados) => {
      try {
        if (dados.ncm) {
          await store.dispatch("compras/editarProdutosNecessidadeNcm", {
            ncm: dados.ncm,
            need_id: id,
            uuid: dados.uuid_item,
          });

          $q.notify({
            message: "NCM editado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          getDados();
        }
      } catch (error) {
        $q.notify({
          message: error.response?.data?.message || "Erro ao editar NCM",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const removerResponsavelItem = async (item) => {
      try {
        await store.dispatch("compras/removerResponsavelNecessidade", {
          uuid: id,
          uuidItem: item.uuid_item,
        });

        $q.notify({
          message: "Responsável removido com sucesso!",
          color: "positive",
        });

        getDados();
        emit("atualizar");

        item.matricula_responsavel = null;
      } catch (error) {
        $q.notify({
          message: "Erro ao remover responsável",
          color: "negative",
        });
        console.error(error);
      }
    };

    const selecionarTudo = async () => {
      selecionados.value = ["1"];
      selecionados.value.pop();
      rows.value.forEach((e) => {
        if (e.purchase_order_id == null) {
          selecionados.value.push(e);
        }
      });
    };

    const notificarMudancaPreco = () => {
      emit("preco-alterado");

      setTimeout(() => {
        emit("preco-alterado");
      }, 10);

      setTimeout(() => {
        emit("preco-alterado");
      }, 50);
    };

    const resetarEstadoIncluir = () => {
      emit("preco-alterado");
      setTimeout(() => emit("preco-alterado"), 10);
      setTimeout(() => emit("preco-alterado"), 50);
    };

    const salvarPreco = (row) => {
      const chave = row.uuid_item || row.product_id;
      if (chave) {
        precosEditados.value[chave] = row.price || "";
      }
      notificarMudancaPreco();
    };

    const aplicarPrecos = () => {
      rows.value.forEach((row) => {
        const chave = row.uuid_item || row.product_id;
        if (chave && precosEditados.value[chave] !== undefined) {
          row.price = precosEditados.value[chave];
        }
      });
    };

    const editarResponsavel = async (row, novoResponsavel) => {
      if (!novoResponsavel) return;

      try {
        await store.dispatch("compras/editarProdutosNecessidadeNome", {
          matricula_responsavel:
            novoResponsavel.sap || novoResponsavel.id || novoResponsavel,
          uuid: row.uuid_item,
          need_id: id,
        });

        row.responsavel_nome = novoResponsavel.name || novoResponsavel.nome;

        $q.notify({
          message: "Responsável atualizado com sucesso!",
          color: "positive",
        });

        getDados();
        emit("atualizar");
      } catch (error) {
        $q.notify({
          message: "Erro ao atualizar responsável",
          color: "negative",
        });
        console.error(error);

        row.matricula_responsavel = null;
      }
    };

    const produtosSelecionaveis = computed(() => {
      return rows.value.filter((row) => row.purchase_order_id == null);
    });

    const toggleSelectAll = (value) => {
      if (value) {
        selecionados.value = [...produtosSelecionaveis.value];
      } else {
        selecionados.value = [];
      }
    };

    watch(
      selecionados,
      (newSelection) => {
        newSelection.forEach((produto) => {
          const chave = produto.uuid_item || produto.product_id;
          if (chave && precosEditados.value[chave]) {
            produto.price = precosEditados.value[chave];
          }
        });

        if (newSelection.length === 0) {
          selectAll.value = false;
        } else if (newSelection.length === produtosSelecionaveis.value.length) {
          selectAll.value = true;
        } else {
          selectAll.value = false;
        }
      },
      { deep: true }
    );

    watch(
      () => rows.value,
      () => {
        aplicarPrecos();
      },
      { deep: true }
    );

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    watch(
      () => props.get,
      () => {
        getDados();
      }
    );

    return {
      pagination,
      rows,
      disable,
      columns,
      getDados,
      handleRequest,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selecionados,
      selectAll,
      rota,
      exportar,
      deletar,
      selecionarTudo,
      criarRequisicao,
      editar,
      editarNcm,
      excluirCodigo,
      removerResponsavelItem,
      notificarMudancaPreco,
      resetarEstadoIncluir,
      salvarPreco,
      aplicarPrecos,
      editarResponsavel,
      produtosSelecionaveis,
      toggleSelectAll,
      formatQuantidade,
      formatPreco,
    };
  },
};
</script>

<style scoped>
.q-table td:nth-child(3) {
  position: relative;
  padding-right: 30px !important;
}

.align {
  align-items: center;
}

.no-wrap {
  flex-wrap: nowrap !important;
}

.target {
  cursor: pointer;
  color: #4a93f8;
}

.my-special-class {
  background-color: #c1dec1 !important;
}
tbody tr td {
  white-space: pre-wrap;
}
</style>
